import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/followUp/followUp";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import NearlyExhaustedContactList from "./smartComponents/nearlyExhaustedContactList";
import LearnMore from "../../../components/learnMore/learnMore";
import IntroPurchasedNoVisit from "./smartComponents/introPurchasedNoVisit";
import PifRenewalsToday from "./smartComponents/pifRenewalsToday";
import MembershipUpgradesToday from "./smartComponents/membershipUpgradesToday";
import NearlyExhaustedToday from "./smartComponents/nearlyExhaustedToday";
import IntrosExpiring from "./smartComponents/introsExpiring";

export class LeadsModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      moduleHeight: 650
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Follow Up")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (isModuleActive(state.dashboardConfigurator.preferences, "Follow Up") && !this.state.initRequest) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    if (this.props.currentUser.permissions.dashboard_nearly_exhausted_class_packages_module) {
      this.setState({
        moduleHeight: 800
      });
    }

    if (this.props.currentUser.permissions.dashboard_visitors_today_list_module) {
      this.setState({
        moduleHeight: 850
      });
    }

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  render() {
    return (
      <SectionToggle
        title={"Follow Up"}
        learnMore={<LearnMore {...learnMoreProps()} />}
        customClass="followupWidget"
        height={this.state.moduleHeight}
        isLoading={this.props.isLoading}
        content={
          <div>
            <ReactTooltip html={true} id="tooltips" />
            <div className="section-wrapper" style={{ paddingTop: "50px" }}>
              {this.props.modulePermissions.dashboard_intros_purchased_but_no_visit_module ? (
                <div className="section-group" style={{ width: "33%" }}>
                  <h5>
                    Intro Purchased But No Visit{" "}
                    <span
                      data-for="tooltips"
                      data-tip={"<p>Finds clients from the last 30 days that purchased an introductory offer and have not had a visit.<p>"}
                      className="glyphicon glyphicon-info-sign"
                    />
                  </h5>
                  <span className="donut-left">
                    <IntroPurchasedNoVisit />
                  </span>
                  <span className="donut-right">
                    <span className="double-donut">
                      <p className="total">
                        Total
                        <br />
                        <span>{this.props.followUps.contacted + this.props.followUps.notContacted}</span>
                      </p>
                      <p className="contacted">
                        Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.followUps.contactedRawDataLink}>
                            {this.props.followUps.contacted}
                          </a>
                        </span>
                      </p>
                      <p className="not-contacted">
                        Not Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.followUps.notContactedRawDataLink}>
                            {this.props.followUps.notContacted}
                          </a>
                        </span>
                      </p>
                    </span>
                  </span>
                </div>
              ) : null}

              {this.props.modulePermissions.dashboard_membership_upgrades_module ? (
                <div className="section-group" style={{ width: "33%" }}>
                  <h5>
                    Membership Upgrades{" "}
                    <span
                      data-for="tooltips"
                      data-tip={
                        "<p>Finds clients that have are averaging 1.5 visits per week over the last 3 weeks.<br/>Found clients must not have an active membership and must not have an active paid in full.<p>"
                      }
                      className="glyphicon glyphicon-info-sign"
                    />
                  </h5>
                  <span className="donut-left">
                    <MembershipUpgradesToday />
                  </span>
                  <span className="donut-right">
                    <span className="double-donut">
                      <p className="total">
                        Total
                        <br />{" "}
                        <span>
                          {this.props.membershipUpgradesToday.contactedMembershipUpgrades + this.props.membershipUpgradesToday.notContactedMembershipUpgrades}
                        </span>
                      </p>
                      <p className="contacted">
                        Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.membershipUpgradesToday.contactedMembershipUpgradesLink}>
                            {this.props.membershipUpgradesToday.contactedMembershipUpgrades}
                          </a>
                        </span>
                      </p>
                      <p className="not-contacted">
                        Not Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.membershipUpgradesToday.notContactedMembershipUpgradesLink}>
                            {this.props.membershipUpgradesToday.notContactedMembershipUpgrades}
                          </a>
                        </span>
                      </p>
                    </span>
                  </span>
                </div>
              ) : null}

              {this.props.modulePermissions.dashboard_pif_renewals_module ? (
                <div className="section-group" style={{ width: "33%" }}>
                  <h5>
                    PIF Renewals{" "}
                    <span
                      data-for="tooltips"
                      data-tip={
                        "<p>Finds clients that have paid in full packages that have or will expire in the range of 15 days ago to 15 days in the future.<br/>Found clients must not have an active membership.<p>"
                      }
                      className="glyphicon glyphicon-info-sign"
                    />
                  </h5>
                  <span className="donut-left">
                    <PifRenewalsToday />
                  </span>
                  <span className="donut-right">
                    <span className="double-donut">
                      <p className="total">
                        Total
                        <br />
                        <span>{this.props.pifRenewal.contactedPifRenewal + this.props.pifRenewal.notContactedPifRenewal}</span>
                      </p>
                      <p className="contacted">
                        Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.pifRenewal.contactedPifRenewalLink}>
                            {this.props.pifRenewal.contactedPifRenewal}
                          </a>
                        </span>
                      </p>
                      <p className="not-contacted">
                        Not Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.pifRenewal.notContactedPifRenewalLink}>
                            {this.props.pifRenewal.notContactedPifRenewal}
                          </a>
                        </span>
                      </p>
                    </span>
                  </span>
                </div>
              ) : null}

              {this.props.modulePermissions.dashboard_intros_expiring_module ? (
                <div className="section-group" style={{ width: "33%" }}>
                  <h5>
                    Intros Expiring{" "}
                    <span
                      data-for="tooltips"
                      data-tip={
                        "<p>Finds unconverted clients that have intros that expired in the last 7 days or will expire tomorrow or today.<br/>Found clients must not have already converted.<p>"
                      }
                      className="glyphicon glyphicon-info-sign"
                    />
                  </h5>

                  <span className="donut-left">
                    <IntrosExpiring />
                  </span>
                  <span className="donut-right">
                    <span className="double-donut">
                      <p className="total">
                        Total
                        <br />
                        <span>{this.props.introsExpiring.contactedExpiringIntros + this.props.introsExpiring.notContactedExpiringIntros}</span>
                      </p>
                      <p className="contacted">
                        Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.introsExpiring.contactedExpiringIntrosLink}>
                            {this.props.introsExpiring.contactedExpiringIntros}
                          </a>
                        </span>
                      </p>
                      <p className="not-contacted">
                        Not Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.introsExpiring.notContactedExpiringIntrosLink}>
                            {this.props.introsExpiring.notContactedExpiringIntros}
                          </a>
                        </span>
                      </p>
                    </span>
                  </span>
                </div>
              ) : null}
            </div>
            <div className="section-wrapper" style={{ paddingTop: "50px" }}>
              {this.props.modulePermissions.dashboard_nearly_exhausted_class_packages_module ? (
                <div className="section-group">
                  <h5>
                    Nearly Exhausted Packages{" "}
                    <span
                      data-for="tooltips"
                      data-tip={
                        "<p>Finds clients that have had a visit in the last 90 days and have an active class package with one or two remaining sessions.<br/>Found clients must not have an active paid in full or membership.<p>"
                      }
                      className="glyphicon glyphicon-info-sign"
                    />
                  </h5>

                  <span className="donut-left" style={{ width: "28%" }}>
                    <NearlyExhaustedToday />
                  </span>
                  <span className="donut-right">
                    <span className="double-donut">
                      <p className="total">
                        Total
                        <br />
                        <span>{this.props.nearlyExhausted.contacted + this.props.nearlyExhausted.notContacted}</span>
                      </p>
                      <p className="contacted">
                        Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.nearlyExhausted.contactedRawDataLink}>
                            {this.props.nearlyExhausted.contacted}
                          </a>
                        </span>
                      </p>
                      <p className="not-contacted">
                        Not Contacted:&nbsp;
                        <span>
                          <a target="_raw_data_tab" href={this.props.nearlyExhausted.notContactedRawDataLink}>
                            {this.props.nearlyExhausted.notContacted}
                          </a>
                        </span>
                      </p>
                    </span>
                  </span>
                </div>
              ) : null}

              {this.props.modulePermissions.dashboard_visitors_today_list_module && this.props.currentUser.sourceType === "mindbody" ? (
                <div className="section-group" style={{ paddingTop: "41px" }}>
                  <span>
                    <SectionContainer customStyles="no-top-padding" title="Today's Follow Up List">
                      <NearlyExhaustedContactList />
                    </SectionContainer>
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        }
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.followUp.isLoading,
    userParams: state.followUp.currentUser,
    followUps: state.followUp.followUps,
    nearlyExhausted: state.followUp.nearlyExhausted,
    membershipUpgradesToday: state.followUp.membershipUpgradesToday,
    pifRenewal: state.followUp.pifRenewalToday,
    introsExpiring: state.followUp.introsExpiring,
    modulePermissions: state.followUp.currentUser.permissions
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(LeadsModule);

LeadsModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  followUps: PropTypes.object,
  nearlyExhausted: PropTypes.object,
  membershipUpgradesToday: PropTypes.object,
  pifRenewal: PropTypes.object,
  modulePermissions: PropTypes.object,
  introsExpiring: PropTypes.object
};

const learnMoreProps = () => {
  return {
    learnMoreId: "follow_up_module",
    title: "Follow Up",
    content: (
      <>
        Use these lists to find valuable and procured lists of clients to follow up with.
        <br />
        <br />
        Click on contacted or not contacted metrics to find the full list of clients as well as useful information like email and phone number.
        <br />
        <br />
        Contacted clients have a contact log in the last 30 days and not contacted clients do not. Excludes system generated contact logs (if applicable) like
        receipts and class reminders.
      </>
    )
  };
};
